import request from "../libs/request";

import { BuildingId } from "../types/building";

import { BuildingSpaceIdRequest } from "./buildingServices";

export type ToiletCompartmentInfo = {
  toiletCompartmentId: string;
  toiletCompartmentName: string;
  tag: ToiletTagInfo[];
};

export type ToiletTagInfo = {
  value: number;
  battery: number;
  tagId: string;
  tagName: string;
  updatedAt: string;
  count: number;
};

export type GenderType = "M" | "F";

export type ToiletInfo = {
  clean: ToiletTagInfo[];
  open: ToiletTagInfo[];
  compartments: ToiletCompartmentInfo[];
  spaceToiletId: string;
  toiletName: string;
  buildingFloorId: string;
  floorName: string;
  gender: GenderType;
};

export type FloorToiletInfo = {
  buildingFloorId: string;
  floorName: string;
  toilets: ToiletInfo[];
};

export type BuildingToiletInfo = BuildingId & {
  buildingName: string;
  floors: FloorToiletInfo[];
};

export const getToiletMonitoringInfo = async (params: Partial<BuildingId>) =>
  request.get<BuildingToiletInfo[]>("iot/monitoring/toilet", { params });

export const TAG_TYPE = {
  TEMPERATURE: 1,
  HUMIDITY: 2,
  BATTERY: 3,

  AWAIR_TEMPERATURE: 4,
  AWAIR_HUMIDITY: 5,
  CO2: 6,
  CHEMICAL: 7,
  DUST: 8,
  LIGHT: 9,
  NOISE: 10,
  AWAIR_SCORE: 11,
};

export type TagInfo = {
  value: number | null;
  tagId: string;
  tagName: string;
  updatedAt: string | null;
  tagTypeId: number;
  tagTypeName: string;
  tagTypeUnit: string;
};

export type SpaceTempHumidInfo = {
  buildingSpaceId: string;
  spaceName: string;
  tag: TagInfo[];
};

export type FloorTempHumidInfo = {
  buildingFloorId: string;
  floorName: string;
  spaces: SpaceTempHumidInfo[];
};

export type TempHumidInfo = BuildingId & {
  buildingName: string;
  floors: FloorTempHumidInfo[];
};

export const getMonitoringTempHumid = async (params: Partial<BuildingId>) =>
  request.get<TempHumidInfo[]>("iot/monitoring/tempHumid", { params });

export type AirTagInfo = TagInfo & {
  level: string;
  text: string;
};

export type SpaceAirInfo = {
  buildingSpaceId: string;
  spaceName: string;
  tag: AirTagInfo[];
};

export type FloorAirInfo = {
  floorText: string;
  floorLevel: string;
  buildingFloorId: string;
  floorName: string;
  spaceName: string;
  spaces: SpaceAirInfo[];
};

export type AirInfo = BuildingId & {
  buildingName: string;
  floors: FloorAirInfo[];
};

export const getMonitoringAir = async (params: Partial<BuildingId>) =>
  request.get<AirInfo[]>("iot/monitoring/air", { params });

export type ToiletCleaningInfo = {
  tagId: string;
  cleaningYn: boolean;
};

export const putToiletCleaning = async (params: ToiletCleaningInfo) =>
  request.put(
    "iot/monitoring/toilet/cleaning?tagId=" + params.tagId,
    "&cleaningYn=" + params.cleaningYn
  );

export type AirSpaceGraph = {
  time: string;
  temperature: string;
  humidity: string;
};

export type AirSpaceAverage = {
  average: string;
  averageMin: string;
  averageMax: string;
};

export type AirSpaceInfo = {
  graphData: AirSpaceGraph[];
  averageTemperature: AirSpaceAverage;
  averageHumidity: AirSpaceAverage;
};

export const getMonitoringAirSpace = (params: BuildingSpaceIdRequest) =>
  request.get<AirSpaceInfo>(`/iot/monitoring/air/${params.buildingSpaceId}`);
